<template>
    <div class="label-input datepicker">
        <label :for="id_">{{ label }}</label>

        <v-menu
            :attach="'#' + id_"
            v-model="showPicker"
            :close-on-content-click="false"
            transition="slide-y-transition"
            full-width
            max-width="290px"
            min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <div v-on="on" :id="id_">
                    <input
                        v-model="dateFormatted"
                        type="text"
                        placeholder="DD.MM.RRRR"
                        @blur="date = parseDate(dateFormatted)"
                        :class="inputClassObject"
                      />
                </div>
            </template>
            <v-date-picker
                v-model="date"
                no-title @input="showPicker = false"
                first-day-of-week="1"
                :locale="language"
                :name="name_"
            ></v-date-picker>
        </v-menu>

        <MErrors v-if="errors_" :errors="errors_"/>
    </div>
</template>

<script>
    import {createNameFromVModelExpr} from '../../index';
    import MErrors from "./MErrors";

    export default {
        name: "MInputDatepicker",
        components: {MErrors},
        data: vm => ({
            language: 'cs',
            id_: vm.id,
            name_: vm.name,
            date: vm.value,
            dateFormatted: vm.formatDate(vm.value),
            showPicker: false,
        }),
        props: {
            format: {
                type: String,
                default: "d.M.yyyy",
            },
            id: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                required: false,
            },
            label: {
                type: String,
                default: '',
            },
            value: {
                type: String,
                default: '',
            },
            errors: {
                type: Object,
                default() {
                    return {}
                }
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            typeable: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            errors_() {
                return this.errors.getOwnPropertyDescriptor(this.name_) ? this.errors[this.name_] : false;
            },
            inputClassObject() {
                return this.errors_ ? ['warning'] : [];
            }
        },
        watch: {
            date (val) {
                this.dateFormatted = this.formatDate(this.date);
                // get Date object, return date string in format 'yyyy-mm-dd'
                this.$emit('input', val);
            },
        },
        methods: {
            formatDate (date) {
                if (!date) return null;

                const [year, month, day] = date.split('-');
                return `${day}.${month}.${year}`;
            },
            parseDate (date) {
                if (!date) return null;

                const [day, month, year] = date.split('.');
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            },
        },
        created() {
            const id = createNameFromVModelExpr(this);
            const name = this.$vnode.data.model.expression;

            if (id && !this.id_)
                this.id_ = id;

            if (name && !this.name_)
                this.name_ = name;
        }
    }
</script>

<style scoped>

</style>